import useAccountInfo from '../../hooks/useAccountInfo';
import { Tenancy } from '@hud/portal-dtos/webapp-common.dto';
import { Navigation } from '../Navigation/Navigation';
import * as Styled from './SidebarV2.styles';
import { useBooleanFeatureFlag } from '../../hooks/useFeatureFlags';
import { Link } from '../Link/Link';
import { HudIcon } from '@hud/web-components/Icons/HudIcons';

const SettingsSidebar = () => {
  const { data: accountInfoData } = useAccountInfo();
  const slackIntegrationEnabled = useBooleanFeatureFlag('enable-slack-integration');

  return (
    <Styled.Container>
      <div className="header">
        <Link className="backToApp" to="/">
          <HudIcon icon="designSystem.chevronLeft" size="20px" />
          <span>Back to app</span>
        </Link>
      </div>

      <div className="body">
        <Navigation.Group>
          {accountInfoData?.tenancy !== Tenancy.enum.single && (
            <Navigation.Link icon="other.users" to={`/settings/members`} replace>
              Members
            </Navigation.Link>
          )}
          {slackIntegrationEnabled && (
            <Navigation.Link icon="designSystem.bell" to={`/settings/slack`} replace>
              Slack Integration
            </Navigation.Link>
          )}
          <Navigation.Link icon="other.key" to={`/settings/api-keys`} replace>
            API Keys
          </Navigation.Link>
          <Navigation.Link icon="other.flame" to={`/settings/heads-up`} replace>
            Heads Up
          </Navigation.Link>
        </Navigation.Group>
      </div>
    </Styled.Container>
  );
};

export default SettingsSidebar;
